module.exports = __webpack_public_path__ + "static/media/image_19.55d5c522.png";